import React from 'react';
import { getAllArticles } from '../../Helpers/ArticleHelpers';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { Typography, ListItem, ListItemText, ListItemSecondaryAction, IconButton, Container, withStyles, Button, Chip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import { Link } from 'react-router-dom';
import { getUserType } from '../../Helpers/UserHelpers';
import MaterialTable from 'material-table';
import Loading from '../Loading/Loading';

const styles = theme => ({
    list: {
        width: '100%'
    },
    chip: {
        marginRight: theme.spacing(1),
        '&last-child': {
            marginRight: 0
        }
    }
})

class ArticlesList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            articles: null,
            rows: [],
            columns: [
                { title: "Title", field: 'title' },
                { title: 'Author', field: 'authorName' },
                { title: 'Visits', field: 'visits' },
                { title: 'Tags', field: 'tags' },
                { title: 'Edit', field: 'edit' }
            ],
            currentPage: 0
        }

        this.getArticles();
    }

    getArticles = () => {
        getUserType(firebase.auth().currentUser.uid).then(async userType => {
            let articles
            if (userType === 'admin') {
                articles = await  getAllArticles()
            } else {
                articles = await getAllArticles(firebase.auth().currentUser)
            }
            this.setState({ articles }, this.setRows)
        }).catch(error => console.log(error))
    }

    createTagsView = (tags) => (
        <div>
            {tags && tags.map(tag => (
                <Chip 
                    label={tag}
                    className={this.props.classes.chip}
                    variant="outlined"
                    color="primary" /> 
            ))}
        </div>
    )

    setRows = () => {
        let articleData
        let rows = []
        const articles = this.state.articles
        if (articles) {
            articles.forEach(articleDoc => {
                articleData = articleDoc.data()
                rows.push({
                    id: articleDoc.id,
                    title: articleData.title,
                    authorName: articleData.authorName,
                    visits: articleData.visits,
                    tags: this.createTagsView(articleData.tags),
                    edit: this.createEditButton(articleDoc.id)
                })
            })
            this.setState({ rows })
        }
    }

    createEditButton = (articleId) => (
        <Link component={IconButton} to={`/articles/edit/${articleId}`} edge='end'>
            <EditIcon />
        </Link>
    )

    renderArticles = () => {
        if (this.state.articles) {
            return this.state.articles.map(articleDoc => {
                const articleData = articleDoc.data();
                return (
                    <ListItem key={articleDoc.id} button>
                        <ListItemText 
                            primary={
                                <div>
                                    <Typography variant="overline">{articleData.title} </Typography>
                                    {"\t"} - {"\t"}
                                    <Typography variant="caption">{articleData.authorName} </Typography>
                                    {"\t"} - {"\t"}
                                    <Typography variant="caption"> <RemoveRedEyeIcon fontSize="inherit" />{articleData.visits}</Typography>
                                </div>
                                } />
                        <ListItemSecondaryAction>
                            <Link component={IconButton} to={`/articles/edit/${articleDoc.id}`} edge='end'>
                                <EditIcon />
                            </Link>
                        </ListItemSecondaryAction>
                    </ListItem>
                )
            })
        } else {
            return (<Loading />)
        }
    }

    render() {
        return (
            <div>
                <Container>
                    <Link component={Button} to="/articles/add" variant="outlined" color="primary">Add Article</Link>
                    <MaterialTable title="Articles" columns={this.state.columns} data={this.state.rows} />
                </Container>
            </div>
        )
    }
}

export default withStyles(styles)(ArticlesList);